export * from './generic-upload.component';
export * from './generic-upload.module';
export * from './generic-upload-translation.service';
export * from './generic-upload-translations.interface';
export * from './generic-upload-translations.defaults';
export * from './generic-upload-translations.de';
